export const environment = {
  production: false,
  baseUrl: "https://in2padel-backend.the-alpha.co/api/backoffice/",

  tap_public_key:"pk_test_3bgiVz6P0deHJkpOZl1SL5Qy",
  tap_merchant_id:"65007036",
};
